<template lang="pug">
div(v-if="hasUser")
  TryNewBack
  .pa-3
    BizLogo
  InvoiceGuard
    .s-vstack
      StripeAccountGuard
</template>

<script>
import InvoiceGuard from "./InvoiceGuard";
import StripeAccountGuard from "./StripeAccountGuard";
import TryNewBack from "/src/components/basic/TryNewBack";

export default {
  name: "AccessGuard",
  components: { InvoiceGuard, StripeAccountGuard, TryNewBack },
  computed: {
    hasUser() {
      return this.$auth.check();
    },
  },
  methods: {},
};
</script>